import { render, staticRenderFns } from "./ContentImage.vue?vue&type=template&id=3d9a8dd2&"
import script from "./ContentImage.vue?vue&type=script&lang=ts&"
export * from "./ContentImage.vue?vue&type=script&lang=ts&"
import style0 from "./ContentImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports